export default __webpack_public_path__ + "images/6991d6f67210ff2b332ca8e935944953-human_rights.jpg";